import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from './utils';

const iconButtonVariants = cva(
  "inline-flex size-[34px] shrink-0 items-center justify-center rounded-md border border-transparent outline-none transition-colors focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      tone: {
        ghost:
          'text-muted-foreground hover:bg-secondary hover:text-foreground active:bg-secondary active:text-foreground',
        quiet: 'bg-primary-quiet text-primary-quiet-foreground active:border-primary',
        primary:
          'bg-primary text-primary-foreground hover:bg-primary-hover active:bg-primary-hover',
      },
    },
    defaultVariants: { tone: 'ghost' },
  },
);

/** Icon-only: no visible label, ever (Figma's own note on this component). The accessible name
 *  comes from `label`; wrap the call site in the `Tooltip` primitive for the hover hint. */
type IconButtonProps = React.ComponentProps<'button'> &
  VariantProps<typeof iconButtonVariants> & {
    label: string;
  };

function IconButton({ className, tone = 'ghost', label, ...props }: IconButtonProps) {
  return (
    <button
      type="button"
      data-slot="icon-button"
      data-tone={tone}
      aria-label={label}
      className={cn(iconButtonVariants({ tone }), className)}
      {...props}
    />
  );
}

export { IconButton, iconButtonVariants };
